import styled from 'styled-components';

export const ScBonusHistory = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  align-items: center;
  width: 100%;

  & > .no-history {
    color: ${({ theme }) => theme.grayColor};
    text-align: center;
    font-size: 14px;
    font-weight: 700;
    line-height: 20px;
    letter-spacing: 0.14px;
  }

  .message {
    color: ${({ theme }) => theme.whiteColor};
  }
`;
